import React, { useState } from 'react';
import { IconButton, IconButtonSize, IconButtonTheme, GenericAlertPopup, useWaitOverlayStore } from '@apply/components';
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { ExperienceType } from '@apply/constants';
import { useDeleteUserExperienceMutation } from '../../../../../../../../../../../queries/userExperienceQueries';
import { ConfirmV2 } from '@apply/ui';

export interface DeleteButtonProps {
    experienceId: number | undefined;
    experienceTypeId: number | undefined;
    isVerified: boolean;
}

export const DeleteButton: React.FC<DeleteButtonProps> = ({ experienceId, experienceTypeId, isVerified }) => {
    const { mutateAsync: deleteExperience } = useDeleteUserExperienceMutation();
    const { setWaiting } = useWaitOverlayStore();

    const [showConfirm, setShowConfirm] = useState(false);

    if (!experienceId) return null;

    const isVisible = !(
        experienceTypeId !== ExperienceType.NonBfi ||
        (!isVerified && experienceTypeId === ExperienceType.NonBfi)
    );

    const isDisabled = experienceTypeId !== ExperienceType.NonBfi || !isVerified;

    const handleClick = () => {
        setShowConfirm(true);
    };

    const handleConfirm = async () => {
        try {
            setWaiting(true);
            await deleteExperience(experienceId);
        } catch (error: any) {
            GenericAlertPopup({
                title: 'Error',
                children: error.message ?? 'Failed to delete experience.',
                width: '350px',
            });
        } finally {
            setWaiting(false);
            setShowConfirm(false);
        }
    };

    const handleCancel = () => {
        setShowConfirm(false);
    };

    return (
        <>
            {isVisible && (
                <IconButton
                    id='deleteExperienceButton'
                    theme={IconButtonTheme.Red}
                    icon={faTrashAlt}
                    size={IconButtonSize.Small}
                    disabled={isDisabled}
                    handleClick={handleClick}
                />
            )}

            <ConfirmV2
                id='deleteUserExperienceConfirm'
                title='Delete Experience'
                open={showConfirm}
                okLabel='Delete'
                cancelLabel='Cancel'
                width='400px'
                onConfirm={handleConfirm}
                onCancel={handleCancel}
            >
                Are you sure you want to delete this experience property?
                <br />
                <br />
            </ConfirmV2>
        </>
    );
};
